// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__1cM5h","notes":"Notes_notes__2jelV","note":"Notes_note__1d6aM","markdown":"Notes_markdown__2z_IH"};